import { SESSION_KINDS } from "../../util/constants";
import { useGetAllSessionsQuery } from "../../services/submissionPeriod/api";
import { Fragment } from "react";
import Exports from "./Export";
import SystemMessage from "./SystemMessage";
import Dates from "./Dates";
import AdminSkeleton from "./Loading";

function Admin(props = {}) {
  const { isLoading } = useGetAllSessionsQuery({ type: SESSION_KINDS.FGC });

  if(isLoading) {
    return <AdminSkeleton />
  }

  return (
    <Fragment>
      <SystemMessage />
      <Dates />
      <Exports />
    </Fragment>
  );
}

export default Admin;
